// AUTO-GENERATED by apps/api-server/scripts/publish-game-art.ts — DO NOT EDIT.
// Run `npm run publish:art` (build:packages does) to refresh.
// Committed so a missing or renamed image fails type-checking, and so reviews
// see art changes.
/** Served game art: id (path under shared-assets/served) → content-hashed URL path. */
export const ART_MANIFEST = {
    "common/avatars/astromech.svg": "/assets/static/common/avatars/astromech.3e86e472.svg",
    "common/avatars/cathar.svg": "/assets/static/common/avatars/cathar.d1d7f9c1.svg",
    "common/avatars/chiss.svg": "/assets/static/common/avatars/chiss.1d696c1e.svg",
    "common/avatars/human-a.svg": "/assets/static/common/avatars/human-a.a0994d00.svg",
    "common/avatars/human-b.svg": "/assets/static/common/avatars/human-b.5481a323.svg",
    "common/avatars/hunter.svg": "/assets/static/common/avatars/hunter.84edb33b.svg",
    "common/avatars/jawa.svg": "/assets/static/common/avatars/jawa.d1a87903.svg",
    "common/avatars/jedi.svg": "/assets/static/common/avatars/jedi.03b0f14f.svg",
    "common/avatars/miraluka.svg": "/assets/static/common/avatars/miraluka.cd2baee9.svg",
    "common/avatars/mirialan.svg": "/assets/static/common/avatars/mirialan.0e80dfa9.svg",
    "common/avatars/nautolan.svg": "/assets/static/common/avatars/nautolan.d37ba8da.svg",
    "common/avatars/officer.svg": "/assets/static/common/avatars/officer.3d48aed5.svg",
    "common/avatars/pilot.svg": "/assets/static/common/avatars/pilot.744c83f8.svg",
    "common/avatars/probe.svg": "/assets/static/common/avatars/probe.6f99914d.svg",
    "common/avatars/protocol.svg": "/assets/static/common/avatars/protocol.54cd9e0d.svg",
    "common/avatars/rattataki.svg": "/assets/static/common/avatars/rattataki.0a278767.svg",
    "common/avatars/rodian.svg": "/assets/static/common/avatars/rodian.1787c735.svg",
    "common/avatars/sith-hood.svg": "/assets/static/common/avatars/sith-hood.ac5725ec.svg",
    "common/avatars/sith.svg": "/assets/static/common/avatars/sith.a8e7db5e.svg",
    "common/avatars/togruta.svg": "/assets/static/common/avatars/togruta.41d24a74.svg",
    "common/avatars/trandoshan.svg": "/assets/static/common/avatars/trandoshan.c310e3eb.svg",
    "common/avatars/trooper.svg": "/assets/static/common/avatars/trooper.70d03387.svg",
    "common/avatars/twilek.svg": "/assets/static/common/avatars/twilek.9071f3d7.svg",
    "common/avatars/zabrak.svg": "/assets/static/common/avatars/zabrak.d42081db.svg",
    "common/round-icons/ROUND-1.png": "/assets/static/common/round-icons/ROUND-1.b6558e36.webp",
    "common/round-icons/ROUND-2.png": "/assets/static/common/round-icons/ROUND-2.b20b7bf9.webp",
    "common/round-icons/ROUND-3.png": "/assets/static/common/round-icons/ROUND-3.e373357a.webp",
    "common/round-icons/ROUND-4.png": "/assets/static/common/round-icons/ROUND-4.7f7a3510.webp",
    "common/round-icons/ROUND-FINAL.png": "/assets/static/common/round-icons/ROUND-FINAL.d9ff0d2d.webp",
    "common/round-icons/ROUND-HIDDEN.png": "/assets/static/common/round-icons/ROUND-HIDDEN.91259741.webp",
    "fpr/logo.webp": "/assets/static/fpr/logo.cdae50d5.webp",
    "fpr/roles/dps.png": "/assets/static/fpr/roles/dps.fa6efaeb.webp",
    "fpr/roles/heal.png": "/assets/static/fpr/roles/heal.6ccd1e22.webp",
    "fpr/roles/tank.png": "/assets/static/fpr/roles/tank.5d88aa19.webp",
    "hns/logo.webp": "/assets/static/hns/logo.74231eca.webp",
    "hns/roles/hider.png": "/assets/static/hns/roles/hider.09249e13.webp",
    "hns/roles/seeker.png": "/assets/static/hns/roles/seeker.9efdbb65.webp",
    "hnst/emoji-frogdogs.webp": "/assets/static/hnst/emoji-frogdogs.a7f944ae.webp",
    "hnst/emoji-rotworms.webp": "/assets/static/hnst/emoji-rotworms.b293449e.webp",
    "hnst/frogdogs_banner_vertical.webp": "/assets/static/hnst/frogdogs_banner_vertical.74666cb7.webp",
    "hnst/frogdogs_banner_vertical_solid.webp": "/assets/static/hnst/frogdogs_banner_vertical_solid.f14cf809.webp",
    "hnst/frogdogs_creature-square.webp": "/assets/static/hnst/frogdogs_creature-square.a7f944ae.webp",
    "hnst/frogdogs_creature.webp": "/assets/static/hnst/frogdogs_creature.b212cc60.webp",
    "hnst/frogdogs_creature_solid.webp": "/assets/static/hnst/frogdogs_creature_solid.75c8af64.webp",
    "hnst/frogdogs_frame.webp": "/assets/static/hnst/frogdogs_frame.494b567d.webp",
    "hnst/frogdogs_frame_solid.webp": "/assets/static/hnst/frogdogs_frame_solid.7f9bf5c1.webp",
    "hnst/frogdogs_logo_framed.webp": "/assets/static/hnst/frogdogs_logo_framed.c458861b.webp",
    "hnst/frogdogs_logo_framed_solid.webp": "/assets/static/hnst/frogdogs_logo_framed_solid.0642e776.webp",
    "hnst/logo.png": "/assets/static/hnst/logo.e6a3eb02.webp",
    "hnst/rotworms_banner_vertical.webp": "/assets/static/hnst/rotworms_banner_vertical.cb922170.webp",
    "hnst/rotworms_banner_vertical_solid.webp": "/assets/static/hnst/rotworms_banner_vertical_solid.9d9f7ea0.webp",
    "hnst/rotworms_creature-square.webp": "/assets/static/hnst/rotworms_creature-square.b293449e.webp",
    "hnst/rotworms_creature.webp": "/assets/static/hnst/rotworms_creature.a23ed05b.webp",
    "hnst/rotworms_creature_solid.webp": "/assets/static/hnst/rotworms_creature_solid.960e1ee2.webp",
    "hnst/rotworms_frame.webp": "/assets/static/hnst/rotworms_frame.eda5a076.webp",
    "hnst/rotworms_frame_solid.webp": "/assets/static/hnst/rotworms_frame_solid.4c45884a.webp",
    "hnst/rotworms_logo_framed.webp": "/assets/static/hnst/rotworms_logo_framed.fd49800c.webp",
    "hnst/rotworms_logo_framed_solid.webp": "/assets/static/hnst/rotworms_logo_framed_solid.3da39805.webp",
    "ops-race/logo.png": "/assets/static/ops-race/logo.80adb410.webp",
    "trl/logo.webp": "/assets/static/trl/logo.43228519.webp",
    "trl/map-backgrounds/map-bg-1.svg": "/assets/static/trl/map-backgrounds/map-bg-1.c90e0ef7.svg",
    "trl/markers/1.svg": "/assets/static/trl/markers/1.04101a64.svg",
    "trl/markers/10.svg": "/assets/static/trl/markers/10.7b3e9a44.svg",
    "trl/markers/11.svg": "/assets/static/trl/markers/11.3658c372.svg",
    "trl/markers/12.svg": "/assets/static/trl/markers/12.c682cfce.svg",
    "trl/markers/13.svg": "/assets/static/trl/markers/13.3ad5d2b7.svg",
    "trl/markers/14.svg": "/assets/static/trl/markers/14.ec57dff2.svg",
    "trl/markers/15.svg": "/assets/static/trl/markers/15.e6066eae.svg",
    "trl/markers/16.svg": "/assets/static/trl/markers/16.c14e07e9.svg",
    "trl/markers/17.svg": "/assets/static/trl/markers/17.bbada742.svg",
    "trl/markers/18.svg": "/assets/static/trl/markers/18.801fb709.svg",
    "trl/markers/19.svg": "/assets/static/trl/markers/19.2fa9cf54.svg",
    "trl/markers/2.svg": "/assets/static/trl/markers/2.067e2635.svg",
    "trl/markers/20.svg": "/assets/static/trl/markers/20.6e286a5b.svg",
    "trl/markers/21.svg": "/assets/static/trl/markers/21.8b4afab5.svg",
    "trl/markers/22.svg": "/assets/static/trl/markers/22.dab1509b.svg",
    "trl/markers/23.svg": "/assets/static/trl/markers/23.356fcf2e.svg",
    "trl/markers/24.svg": "/assets/static/trl/markers/24.978e6ae3.svg",
    "trl/markers/25.svg": "/assets/static/trl/markers/25.5b3e8242.svg",
    "trl/markers/26.svg": "/assets/static/trl/markers/26.219223df.svg",
    "trl/markers/27.svg": "/assets/static/trl/markers/27.d34093be.svg",
    "trl/markers/28.svg": "/assets/static/trl/markers/28.e4e7ad53.svg",
    "trl/markers/29.svg": "/assets/static/trl/markers/29.bdb957ae.svg",
    "trl/markers/3.svg": "/assets/static/trl/markers/3.e126832e.svg",
    "trl/markers/30.svg": "/assets/static/trl/markers/30.b10736a5.svg",
    "trl/markers/31.svg": "/assets/static/trl/markers/31.b8445ff4.svg",
    "trl/markers/32.svg": "/assets/static/trl/markers/32.85f512c3.svg",
    "trl/markers/33.svg": "/assets/static/trl/markers/33.ac1c49b4.svg",
    "trl/markers/34.svg": "/assets/static/trl/markers/34.ad42171b.svg",
    "trl/markers/35.svg": "/assets/static/trl/markers/35.e0078d39.svg",
    "trl/markers/36.svg": "/assets/static/trl/markers/36.c4aa5ea2.svg",
    "trl/markers/37.svg": "/assets/static/trl/markers/37.706897d0.svg",
    "trl/markers/38.svg": "/assets/static/trl/markers/38.33977a3f.svg",
    "trl/markers/39.svg": "/assets/static/trl/markers/39.c5c3988b.svg",
    "trl/markers/4.svg": "/assets/static/trl/markers/4.5d13e7bf.svg",
    "trl/markers/40.svg": "/assets/static/trl/markers/40.eb71b0f2.svg",
    "trl/markers/41.svg": "/assets/static/trl/markers/41.0fe5403a.svg",
    "trl/markers/42.svg": "/assets/static/trl/markers/42.c11ad289.svg",
    "trl/markers/43.svg": "/assets/static/trl/markers/43.e021d892.svg",
    "trl/markers/44.svg": "/assets/static/trl/markers/44.da2c9bcb.svg",
    "trl/markers/45.svg": "/assets/static/trl/markers/45.ed4ea103.svg",
    "trl/markers/46.svg": "/assets/static/trl/markers/46.2dccd287.svg",
    "trl/markers/47.svg": "/assets/static/trl/markers/47.f4be8eb0.svg",
    "trl/markers/48.svg": "/assets/static/trl/markers/48.b3f9cb3c.svg",
    "trl/markers/49.svg": "/assets/static/trl/markers/49.8dddc6ae.svg",
    "trl/markers/5.svg": "/assets/static/trl/markers/5.258f311d.svg",
    "trl/markers/50.svg": "/assets/static/trl/markers/50.0102889d.svg",
    "trl/markers/51.svg": "/assets/static/trl/markers/51.9cf42212.svg",
    "trl/markers/52.svg": "/assets/static/trl/markers/52.5160e197.svg",
    "trl/markers/53.svg": "/assets/static/trl/markers/53.bffc18c9.svg",
    "trl/markers/54.svg": "/assets/static/trl/markers/54.8b34f3c8.svg",
    "trl/markers/55.svg": "/assets/static/trl/markers/55.7f59ae9c.svg",
    "trl/markers/56.svg": "/assets/static/trl/markers/56.aa1860fc.svg",
    "trl/markers/57.svg": "/assets/static/trl/markers/57.93407aa5.svg",
    "trl/markers/58.svg": "/assets/static/trl/markers/58.28b39fb7.svg",
    "trl/markers/59.svg": "/assets/static/trl/markers/59.23467346.svg",
    "trl/markers/6.svg": "/assets/static/trl/markers/6.e54ba643.svg",
    "trl/markers/60.svg": "/assets/static/trl/markers/60.99d1fb91.svg",
    "trl/markers/61.svg": "/assets/static/trl/markers/61.b5a3ed83.svg",
    "trl/markers/62.svg": "/assets/static/trl/markers/62.8346ad0c.svg",
    "trl/markers/63.svg": "/assets/static/trl/markers/63.b028c87c.svg",
    "trl/markers/64.svg": "/assets/static/trl/markers/64.3eacb1f1.svg",
    "trl/markers/7.svg": "/assets/static/trl/markers/7.9b5c5d83.svg",
    "trl/markers/8.svg": "/assets/static/trl/markers/8.00db107f.svg",
    "trl/markers/9.svg": "/assets/static/trl/markers/9.5359dfa8.svg",
    "trl/rewards/augment.webp": "/assets/static/trl/rewards/augment.78ed1ebf.webp",
    "trl/rewards/credits.webp": "/assets/static/trl/rewards/credits.78ed1ebf.webp",
    "trl/sabotage/con_clue.webp": "/assets/static/trl/sabotage/con_clue.c7eb529e.webp",
    "trl/sabotage/scanner_spy.webp": "/assets/static/trl/sabotage/scanner_spy.550f58f5.webp",
    "trl/sabotage/treasure_thief.webp": "/assets/static/trl/sabotage/treasure_thief.20a936d4.webp",
    "trl/ui/holocomm-alert.webp": "/assets/static/trl/ui/holocomm-alert.37620165.webp",
    "trl/ui/holocomm-idle.webp": "/assets/static/trl/ui/holocomm-idle.33f30653.webp",
    "trl/ui/planet-alert.webp": "/assets/static/trl/ui/planet-alert.16b67309.webp",
    "trl/ui/treasure-chest.webp": "/assets/static/trl/ui/treasure-chest.94ca8753.webp",
    "trl/ui/treasure-found-crest.webp": "/assets/static/trl/ui/treasure-found-crest.56ad745a.webp",
};
